import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class KeepDeserted3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KEEP_DESERTED3;
}

export default KeepDeserted3PoiTileEntity;
